module.exports = __webpack_public_path__ + "static/map-02f14d9e4841913befa821df70b7716e.png";